import React, { useEffect } from 'react';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { history } from './../stores/_helpers';
import { PrivateRoute } from './../stores/_components';

import RouteEnum from '../constants/RouteEnum';
import LoadingIndicator from './components/loading-indicator/LoadingIndicator';
import { HomePage } from './home-page/HomePage';
import { RegisterPage } from './profile-page/pages/register/RegisterPage';
import { AddCustomerPage } from './profile-page/pages/add-customer/AddCustomerPage';
import { AboutPage } from './about-page/AboutPage';
import { TransferPage } from './transfer-page/TransferPage';
import { MyTransferPage } from './my-transfer-page/MyTransferPage';
import { MorePage } from './more-page/MorePage';
import { ContactPage } from './contact-page/ContactPage';
import { MyProfilePage } from './my-profile-page/MyProfilePage';
import { BranchPage } from './branch-page/BranchPage';
import { NewsPage } from './news-page/NewsPage';
import { BeneficaryPage } from './beneficiary-page/BeneficaryPage';
import { CalculatorPage } from './calculator-page/CalculatorPage';
import { LoginPage } from './profile-page/pages/login/LoginPage';
import { MpinPage } from './profile-page/pages/mpin/MpinPage';
import { ForgotPinPage } from './profile-page/pages/forgot-pin/ForgotPage';
import { ForgotPassPage } from './profile-page/pages/forgot-pass/ForgotPassPage';
import { ResetPassPage } from './profile-page/pages/reset-password/ResetPassPage';
import { ResetMpinPage } from './profile-page/pages/reset-mpin/ResetMpinPage';
import { SetCredentialsPage } from './profile-page/pages/set-credentials/SetCredPage';
import { RatesPage } from './rates-page/RatesPage';
import { TermConditionPage } from './profile-page/pages/term-condition/TermConditionPage';
import { TranscationRef } from './transcation-ref/TranscationRef';
import { NotFoundPage } from './not-found-page/NotFoundPage';
import { VerifyOtp } from './profile-page/pages/verify-otp/VerifyOtpPage';
import { ChangePasswordPage } from './profile-page/pages/change-pass/ChangePasswordPage';
// import { alertActions } from '../stores/_actions';
function App() {
  // const alert = useSelector((state) => state.alert);
  // console.log(alert);
  // const dispatch = useDispatch();
  // useEffect(() => {
  //   history.listen((location, action) => {
  //     // clear alert on location change
  //     dispatch(alertActions.clear());
  //   });
  // }, []);

  return (
    <LoadingIndicator>
      {/* {alert.message &&
         <div className={`alert ${alert.type}`}>{alert.message}</div>
       } */}
      <Router history={history}>
        <Switch>
          <Route path={RouteEnum.Home} component={HomePage} />
          <Route exact={true} path={RouteEnum.Login} component={LoginPage} />
          <Route path={RouteEnum.Register} component={RegisterPage} />
          <Route path={RouteEnum.AddCustomer} component={AddCustomerPage} />
          <Route path={RouteEnum.About} component={AboutPage} />
          <Route path={RouteEnum.Transfer} component={TransferPage} />
          <Route path={RouteEnum.Mytransfer} component={MyTransferPage} />
          <Route path={RouteEnum.Branch} component={BranchPage} />
          <Route path={RouteEnum.News} component={NewsPage} />
          <Route path={RouteEnum.Beneficiary} component={BeneficaryPage} />
          <Route path={RouteEnum.Calculator} component={CalculatorPage} />
          <Route path={RouteEnum.Rates} component={RatesPage} />
          <Route path={RouteEnum.Mpin} component={MpinPage} />
          <Route path={RouteEnum.VerifyOtp} component={VerifyOtp} />
          <Route path={RouteEnum.ForgotPin} component={ForgotPinPage} />
          <Route path={RouteEnum.ForgotPass} component={ForgotPassPage} />
          <Route path={RouteEnum.ResetPass} component={ResetPassPage} />
          <Route path={RouteEnum.ResetPin} component={ResetMpinPage} />
          <Route path={RouteEnum.SetCredentials} component={SetCredentialsPage} />
          <Route path={RouteEnum.Profile} component={MyProfilePage} />
          <Route path={RouteEnum.TranscationView} component={TranscationRef} />
          <Route path={RouteEnum.TermCondition} component={TermConditionPage} />
          <Route path={RouteEnum.More} component={MorePage} />
          <Route path={RouteEnum.Contact} component={ContactPage} />
          <Route path={RouteEnum.ChangePassword} component={ChangePasswordPage} />
          <Route path={RouteEnum.notfound} component={NotFoundPage} />
          {/* <Redirect from="*" to="/" /> */}
        </Switch>
      </Router>
    </LoadingIndicator>
  );
}

export { App };

// import React, { Suspense, lazy } from 'react';
// import { ConnectedRouter } from 'connected-react-router';
// import { Route, Switch } from 'react-router-dom';
// import RouteEnum from '../constants/RouteEnum';
// import LoadingIndicator from './components/loading-indicator/LoadingIndicator';
// // import Toasts from './components/toasts/Toasts';

// const HomePage = lazy(() => import('./home-page/HomePage'));
// const AddCustomerPage = lazy(() => import('./profile-page/pages/add-customer/AddCustomerPage'));
// const AboutPage = lazy(() => import('./about-page/AboutPage'));
// const TransferPage = lazy(() => import('./transfer-page/TransferPage'));
// const BranchPage = lazy(() => import('./branch-page/BranchPage'));
// const NewsPage = lazy(() => import('./news-page/NewsPage'));
// const BeneficiaryPage = lazy(() => import('./beneficiary-page/BeneficaryPage'));
// const CalculatorPage = lazy(() => import('./calculator-page/CalculatorPage'));
// const LoginPage = lazy(() => import('./profile-page/pages/login/LoginPage'));
// const RegisterPage = lazy(() => import('./profile-page/pages/register/RegisterPage'));
// const ForgotPinPage = lazy(() => import('./profile-page/pages/forgot-pin/ForgotPage'));
// const MpinPage = lazy(() => import('./profile-page/pages/mpin/MpinPage'));
// const ResetPassPage = lazy(() => import('./profile-page/pages/reset-password/ResetPassPage'));
// const SetCredentialsPage = lazy(() => import('./profile-page/pages/set-credentials/SetCredPage'));
// const RatesPage = lazy(() => import('./rates-page/RatesPage'));
// const TermPage = lazy(() => import('./profile-page/pages/term-condition/TermConditionPage'));
// const NotFoundPage = lazy(() => import('./not-found-page/NotFoundPage'));
// const MorePage = lazy(() => import('./more-page/MorePage'));

// export default class App extends React.Component {
//   render() {
//     return (
//       <ConnectedRouter history={this.props.history}>
//         <Suspense fallback={<LoadingIndicator isActive={true} />}>
//           {/* <MainNav /> */}
//           <Switch>
//             <Route exact={true} path={RouteEnum.Home} component={HomePage} />
//             <Route path={RouteEnum.AddCustomer} component={AddCustomerPage} />
//             <Route path={RouteEnum.About} component={AboutPage} />
//             <Route path={RouteEnum.Transfer} component={TransferPage} />
//             <Route path={RouteEnum.Branch} component={BranchPage} />
//             <Route path={RouteEnum.News} component={NewsPage} />
//             <Route path={RouteEnum.Beneficiary} component={BeneficiaryPage} />
//             <Route path={RouteEnum.Calculator} component={CalculatorPage} />
//             <Route path={RouteEnum.Rates} component={RatesPage} />
//             <Route path={RouteEnum.Login} component={LoginPage} />
//             <Route path={RouteEnum.Mpin} component={MpinPage} />
//             <Route path={RouteEnum.ForgotPin} component={ForgotPinPage} />
//             <Route path={RouteEnum.ResetPass} component={ResetPassPage} />
//             <Route path={RouteEnum.SetCredentials} component={SetCredentialsPage} />
//             <Route path={RouteEnum.Register} component={RegisterPage} />
//             <Route path={RouteEnum.TermCondition} component={TermPage} />
//             <Route path={RouteEnum.More} component={MorePage} />
//             <Route component={NotFoundPage} />
//           </Switch>
//         </Suspense>
//       </ConnectedRouter>
//     );
//   }
// }
